var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.acquired)?_c('el-row',{attrs:{"gutter":30}},[_c('el-col',{staticClass:"alignCenter",attrs:{"span":24}},[_c('article',{domProps:{"innerHTML":_vm._s(_vm.prescription)}})])],1):_c('div',[_c('el-alert',{attrs:{"title":"暂无","type":"info"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }